import codes from 'country-calling-code';

const COUNTRY_CODES: string[] = codes.map(({countryCodes}) => countryCodes?.[0]);

export function extractCountryCode(phone: string): string | null {
  if(!phone) return null;
  const digits = phone.replace('+', '');
  for(let len = 4; len >= 1; len--) {
    const code = digits.slice(0, len);
    if(COUNTRY_CODES.includes(code)) {
      return code;
    }
  }
  return null;
}